import axios from "axios";
import { getAuth } from "firebase/auth";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

let cachedToken = null;
let tokenExpiry = null;

api.interceptors.request.use(async (config) => {
  const auth = getAuth();
  const user = auth.currentUser;

  if (user) {
    const now = Date.now();

    if (!cachedToken || now > tokenExpiry) {
      const tokenResult = await user.getIdTokenResult(true);
      cachedToken = tokenResult.token;
      tokenExpiry = new Date(tokenResult.expirationTime).getTime() - 30000; // 30s buffer
    }

    config.headers.Authorization = `Bearer ${cachedToken}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    const status = error?.response?.status;
    const shouldRetry =
      (status === 401 || status === 403) && !originalRequest._retry;

    if (shouldRetry) {
      originalRequest._retry = true;

      try {
        const auth = getAuth();
        const user = auth.currentUser;

        if (user) {
          // Force-refresh the token
          const newToken = await user.getIdToken(true);

          // Update Authorization header
          originalRequest.headers.Authorization = `Bearer ${newToken}`;

          // Retry the original request
          return api(originalRequest);
        }
      } catch (err) {
        console.warn("Token refresh failed", err);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
